<template>
  <div class="rightconover">
    <div class="contentwidth" v-loading="loading" :element-loading-text="config.loading.text"
      :element-loading-spinner="config.loading.spinner" :element-loading-background="config.loading.background">
      <div class="ContentMargin">
        <div class="content_head">
          <div class="content_head_ico">
            <img src="@/assets/images/worktable/titleguoducolor.png" alt="" />
          </div>
          <div class="content_head_title">质量档案</div>
          <div class="content_head_button">
            <div class="content_head_seek content_searchlistbox">
              <lk-button img="searchlist.png" @click="searchlistshow = !searchlistshow"></lk-button>
              <img v-show="searchlistshow" class="content_searchlist" src="@/assets/images/xiala.png" />
            </div>
            <lk-button style="margin-left: 30px;" @click="exportExcl"> 导出</lk-button>
          </div>
          <!-- <div class="content_head_seek">
              <el-input placeholder="输入流水号" v-model="searchKey" class="input-with-select"></el-input>
            </div>
            <div class="content_head_seek">
              <el-input placeholder="输入车牌号" v-model="searchKey2" class="input-with-select"></el-input>
            </div> -->
        </div>
        <div class="searchlistbox" v-show="searchlistshow">
          <div class="content_head_seek">
            <el-input placeholder="输入流水号" v-model="searchKey.inOutNumber" class="input-with-select"></el-input>
          </div>
          <div class="content_head_seek">
            <el-input placeholder="输入车牌号" v-model="searchKey.carNumber" class="input-with-select"></el-input>
          </div>
          <!-- // 筛选项：货位号、品种，粮权单位，检验时间 -->
          <div class="content_head_seek">
            <el-cascader placeholder="选择货位" v-model="searchKey.barnSon" :options="barnSonInfoList" clearable filterable/>
          </div>
          <div class="content_head_seek">
            <el-cascader v-model="searchKey.grainKind" :options="grainKindList" placeholder="请选择粮食品种" clearable filterable :show-all-levels="false"/>
          </div>
          <div class="content_head_seek">
            <el-select v-model="searchKey.grainBelong" filterable placeholder="请选择粮权所属">
              <el-option v-for="item in grainmanagementData" :key="item.value" :label="item.label"
                :value="item.value" />
            </el-select>
          </div>
          <div class="content_head_seek">
            <el-date-picker v-model="searchKey.timepicker" value-format="yyyy-MM-dd" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </div>
          <div class="content_head_seek">
            <lk-button @click="searchClick">查询</lk-button>
          </div>
          <div class="content_head_seek">
            <lk-button type="lk_button_blue" @click="search_ret">重置
            </lk-button>
          </div>
        </div>
        <div class="Notice_list">
          <el-table :data="Notice" border style="width: 100%">
            <el-table-column width="180" :prop="el.prop" :label="el.label" align="center" v-for="(el,ind) in rowData" :key="ind" />
          </el-table>
        </div>
        <div class="paging">
          <div class="block">
            <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
              layout="total, prev, pager, next, jumper" :total="totalPage">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { checkisnull,export2Excel } from "@/utils/util";
import { httpToken } from "@/utils/http";
import { getGrainKindDictionary } from "@/utils/warehouseInOut";
import { getallSonsBarn,getGrainmanagement } from "@/utils/pulldata";
import qs from "qs";
export default {
  data() {
    return {
      // 货位号、品种，粮权单位，检验时间，检验员，
// 筛选项：货位号、品种，粮权单位，检验时间
      rowData:[
        {prop:'inOutNumber',label:'出入库流水号'},
        {prop:'carSheepNumber',label:'车牌号'},
        {prop:'vbarnName',label:'货位号'},
        {prop:'grainKind',label:'粮食品种'},
        {prop:'grainBelong',label:'粮权所属'},
        {prop:'skewerTime',label:'检验时间'},
        {prop:'skewerName',label:'检验人员'},
      ],
      searchKey:{
        inOutNumber:'',//流水号
        carNumber:'',//车牌号
        barnSon:'',//货位
        grainKind:'',//粮食品种
        grainBelong:'',//粮权所属
        timepicker:null,//时间
      },
      searchlistshow:false,
      loading: false,
      // 历史构造器
      datasearchjson: [],
      currentPage: 1,
      totalPage: 0,
      Notice: [],
      barnSonInfoList:[],//货位下拉数据
      grainKindList: getGrainKindDictionary('id'),
      grainmanagementData:getGrainmanagement(undefined,true),//获取粮权所属下拉数据
    };
  },
  mounted() {
    this.getheadtop()
    getallSonsBarn().then(res=>{
      this.barnSonInfoList=res
    })
  },
  methods: {
    //导出
    exportExcl(){
      let columns=[]
      columns= this.rowData.map(v=>{
        return  { title: v.label, key: v.prop}
      })
export2Excel(columns, this.Notice, "质量档案");
},
    searchClick() {
      let searchjson = this.search_return();
      this.getdatalb(1, searchjson);
    },
    search_ret(){
      this.searchKey={
        inOutNumber:'',//流水号
        carNumber:'',//车牌号
        barnSon:'',//货位
        grainKind:'',//粮食品种
        grainBelong:'',//粮权所属
        timepicker:null,//时间
      }
    },
    search_return() {
      let jsons = [];
      if (!checkisnull(this.searchKey.inOutNumber)) {
        jsons.push({ column: "number", type: 'like', value: this.searchKey.inOutNumber })
      }
      if (!checkisnull(this.searchKey.carNumber)) {
        jsons.push({ column: "car_number", type: 'like', value: this.searchKey.carNumber })
      }
      if (!checkisnull(this.searchKey.barnSon)) {
        jsons.push({ column: "v_barn_id", type: 'like', value: this.searchKey.barnSon[1] })
      }
      if (!checkisnull(this.searchKey.grainKind)) {
        jsons.push({ column: "grain_kind_id", type: 'eq', value: this.searchKey.grainKind[1] })
      }
      if (!checkisnull(this.searchKey.grainBelong)) {
        jsons.push({ column: "grain_belong", type: 'eq', value: this.searchKey.grainBelong })
      }
      if (this.searchKey.timepicker) {
        jsons.push({column: "check_time",type: "ge",value: this.searchKey.timepicker[0] });
        jsons.push({column: "check_time",type: "le",value: this.searchKey.timepicker[1] });
        
      }
      return jsons;
    },
    getheadtop(){
      httpToken({
        method: "post",
        url: "/granary-quality-file/findItems",
        data: qs.stringify({
        }),
      }).then((res) => {
        res.data.data.forEach(item=>{
          this.rowData.push({
            label:item.checkName,
            prop:'assay'+item.id,
          })
        })
        // this.rowData
        this.getdatalb(1)
      })
    },
    // 列表调取 页数 传入构造器
    getdatalb(val, searchjson) {
      this.loading = true;
      let json = [
        { column: "create_date", type: "orderByDesc" }
      ];
      if (searchjson) {
        if (searchjson.__proto__.constructor === Array) {
          for (let i = 0; i < searchjson.length; i++) {
            json.push(searchjson[i]);
          }
        } else {
          json.push(searchjson);
        }
      }
      this.Notice = []
      this.currentPage = val;
      this.datasearchjson = searchjson;
      httpToken({
        method: "post",
        url: "/granary-quality-file/getCheckNum",
        data: qs.stringify({
          page: val,
          paramData: JSON.stringify(json),
          rows: 10,
        }),
      }).then((res) => {
        if (res.data.code == 200) {
          if (val !== res.data.data.current) {
            getdatalb(res.data.data.current, searchjson)
            return
          }
          this.totalPage = res.data.data.total;
          res.data.data.records.forEach(item=>{
            item.qualityCheckInfo.infos.forEach(item2=>{
              item['assay'+item2.assayNameId]=item2.assayValue
            })
            item.inOutNumber=item.qualityCheckInfo.inOutNumber
            item.carSheepNumber=item.qualityCheckInfo.carSheepNumber
            item.skewerTime=item.qualityCheckInfo.skewerTime
            item.skewerName=item.qualityCheckInfo.skewerName
          })
          this.Notice = res.data.data.records;
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    handleCurrentChange(val) {
      this.getdatalb(val, this.datasearchjson);
    },
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/css/model_table_list.scss"; //引入方式
</style>
